/* eslint-disable react/jsx-filename-extension */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const Wrapper = ({ layout = { isboxed: false }, children }) => (
  <div className={`wrapper ${layout.isBoxed ? "wrapper-boxed" : ""}`}>
    {children}
  </div>
);

Wrapper.propTypes = {
  layout: PropTypes.shape({
    isBoxed: PropTypes.bool.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default connect((store) => ({
  layout: store.layout,
}))(Wrapper);
